import { Pipe, PipeTransform } from "@angular/core";
import { getColorByIndex } from "src/app/support/colors";

@Pipe({
  name: "colorByIndex",
  standalone: false
})
export class ColorByIndexPipe implements PipeTransform {
  transform(index: number | undefined): string {
    return getColorByIndex(index);
  }
}
